import React from "react";

// react router
import { Link } from "react-router-dom";

import {
    NewArrivalContainer,
    Title,
    Row,
    Col,
    LinkOuter,
    Image,
    Detail,
    InnerContainer,
    Container,
} from "../../styles/NewArrival";

// images
import potsImg from "assets/images/new-arrivals/pots.jpg";
import sesonalImg from "assets/images/new-arrivals/sesonal.jpg";
import weddingImg from "assets/images/new-arrivals/wedding.jpg";

function NewArrival(props) {
    return (
        <NewArrivalContainer>
            <div className="container">
                <Title>new arrivals</Title>
                <Row className="row">
                    <Col className="col-12 col-sm-4">
                        <InnerContainer>
                            <LinkOuter>
                                <Link
                                    to="/category/pots-planters?id=20"
                                    className="text-decoration-none d-block"
                                >
                                    <Image
                                        src={potsImg}
                                        className="img-fluid"
                                    />
                                    <Detail>Pots</Detail>
                                </Link>
                            </LinkOuter>
                        </InnerContainer>
                    </Col>
                    <Col className="col-12 col-sm-4">
                        <InnerContainer>
                            <LinkOuter>
                                <Link
                                    to="/category/wedding-event?id=32"
                                    className="text-decoration-none d-block"
                                >
                                    <Image
                                        src={sesonalImg}
                                        className="img-fluid"
                                    />
                                    <Detail>Wedding and Event</Detail>
                                </Link>
                            </LinkOuter>
                        </InnerContainer>
                    </Col>
                    <Col className="col-12 col-sm-4">
                        <InnerContainer>
                            <LinkOuter>
                                <Link
                                    to="/category/seasonal?id=42"
                                    className="text-decoration-none d-block"
                                >
                                    <Image
                                        src={weddingImg}
                                        className="img-fluid"
                                    />
                                    <Detail>Seasonal</Detail>
                                </Link>
                            </LinkOuter>
                        </InnerContainer>
                    </Col>
                </Row>
            </div>
        </NewArrivalContainer>
    );
}

export default NewArrival;
